import { FC } from 'react';
import { Button } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import Modal from 'components/shared/Modal';
import useAiContentQueries from 'app/modules/aiContent/hooks/useAiContentQueries';
import useSubscriptionInfo from 'app/hooks/useSubscriptionInfo';
import { useOpenBillingPage } from 'app/hooks/useBillingUrl';
import AiContentRemainingAttemptsBadge from 'app/modules/aiContent/components/AiContentRemainingAttemptsBadge';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const AiContentLimitReachedModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { accountPlanType } = useSubscriptionInfo();
  const { options } = useAiContentQueries({ accountPlanType });
  const openBillingPage = useOpenBillingPage();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      classNames={{ modal: '!tw-w-[400px]', root: '!tw-z-[1003]' }}
      dataName={{ wrapper: 'ai-usage-limit-reached-modal' }}
      dataCy={{ wrapper: 'ai-usage-limit-reached-modal' }}
    >
      <Modal.Content>
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-2 tw-py-6 tw-text-center">
          <div className="tw-text-4xl">✨</div>
          <div>
            <div className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-grayscale-180">
              {t('aiUsageLimitReached.title')}
            </div>
            <div className="tw-text-md tw-text-grayscale-140">
              {t('aiUsageLimitReached.description')}
            </div>
          </div>
          <AiContentRemainingAttemptsBadge options={options} />
        </div>
      </Modal.Content>
      <Modal.Footer className="tw-gap-3">
        <Button className="tw-flex-1" variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          variant="primary"
          className="tw-flex-1"
          data-cy="ai-usage-limit-reached-modal_upgrade-btn"
          onClick={() => openBillingPage('billingPlans', { newTab: true })}
        >
          {t('aiUsageLimitReached.cta')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AiContentLimitReachedModal;
